import LondonHotel1 from '../Assets/Images/london-hotel1.jpg';
import LondonHotel2 from '../Assets/Images/london-hotel2.jpg';
import LondonHotel3 from '../Assets/Images/london-hotel3.jpg';
import LondonHotel4 from '../Assets/Images/london-hotel4.jpg';
import LondonHotel5 from '../Assets/Images/london-hotel5.jpg';
import LondonHotel6 from '../Assets/Images/london-hotel6.jpg';

let LondonCityBreaksItems = [
    {
        id: 1,
        itemImage: LondonHotel1,
        itemTitle: 'Boutique Stay near Soho',
        itemSubTitle: 'London, United Kingdom',
        itemNights: '2 nights',
        itemPrice: '£399'
    },
    {
        id: 2,
        itemImage: LondonHotel2,
        itemTitle: 'Stylish Eco-Friendly Hotel',
        itemSubTitle: 'London, United Kingdom',
        itemNights: '3 nights',
        itemPrice: '£499'
    },
    {
        id: 3,
        itemImage: LondonHotel3,
        itemTitle: 'Classic British Townhouse Hotel',
        itemSubTitle: 'London, United Kingdom',
        itemNights: '2 nights',
        itemPrice: '£799'
    },
    {
        id: 4,
        itemImage: LondonHotel4,
        itemTitle: 'Luxury Corner Suite Experience',
        itemSubTitle: 'London, United Kingdom',
        itemNights: '3 nights',
        itemPrice: '£899'
    },
    {
        id: 5,
        itemImage: LondonHotel5,
        itemTitle: 'Contemporary City View Hotel',
        itemSubTitle: 'London, United Kingdom',
        itemNights: '2 nights',
        itemPrice: '£599'
    },
    {
        id: 6,
        itemImage: LondonHotel6,
        itemTitle: 'Cozy Hidden-Gem Stay',
        itemSubTitle: 'London, United Kingdom',
        itemNights: '3 nights',
        itemPrice: '£399'
    }
];

export default LondonCityBreaksItems;
